<template>
  <div
    class="app-embed"
    :class="appEmbedClass"
  >
    <BaseIframe
      :src="url"
      class="app-embed__iframe"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseIframe from '~/components/BaseComponents/BaseIframe.vue';
  import type { IEmbedContent } from '~/types/common';

  export default defineNuxtComponent({
    name: 'AppEmbed',

    components: {
      BaseIframe,
    },

    props: {
      elem: {
        type: Object as PropType<IEmbedContent>,
        required: true,
      },
    },

    computed: {
      url(): string {
        return this.elem.attributes.url;
      },

      appEmbedClass(): Record<string, boolean> {
        const {
          elem: {
            attributes: { providerNameSlug },
          },
        } = this;

        return {
          [`app-embed--${providerNameSlug}`]: Boolean(providerNameSlug),
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .app-embed {
    position: relative;

    &::before {
      content: '';
      display: block;
      padding-top: 56.15%;
    }

    &__iframe {
      position: absolute;
      bottom: 0;
      height: 100%;
      width: 100%;
    }
  }
</style>
